import { useEffect, useState } from "react";
import { resetInTeamsStoreApp, setInTeamsStoreApp } from '@shared/utils/TeamsUtils';
import { app } from "@microsoft/teams-js";
import { setIsInTeamsApp } from "../store/auth.duck";
import { useDispatch } from "react-redux";

export function WithMsTeamsAppChecker() {
  const [context, setContext] = useState<app.Context | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    app.initialize().then(() => app.getContext()).then((ctx: app.Context) => {
      setContext(ctx);
      dispatch(setIsInTeamsApp(ctx.page.id.includes('teamsapp-')));
    }).catch(() => {
      // Teams SDK context is unavailable outside Teams — nothing to do.
    });
  }, [dispatch]);

  useEffect(() => {
    if (context && context.page.id.includes('teamsapp-')) {
      setInTeamsStoreApp();
    } else {
      resetInTeamsStoreApp();
    }

  }, [context]);
}
